import { useEffect, useRef, useState } from 'react';

import { api, ApiHiba, type EnValasz } from '../api.ts';

/**
 * Belépőképernyő. (3.0 / 1.)
 *
 * Felhasználónévvel és jelszóval, **e-mail nélkül**. Nincs regisztráció: a
 * felhasználókat az adminisztrátor hozza létre. A „maradjak bejelentkezve"
 * a sofőröknek kell, akik telefonon dolgoznak.
 *
 * A hibaüzenet **a lapon belül** jelenik meg, nem felugró ablakban — a
 * böngésző néhány párbeszéd után letiltja azokat, és onnantól némán
 * elmaradnának. (3.0 / 0.)
 */
export function Belepes({ onBelepett }: { onBelepett: (v: EnValasz) => void }) {
  const [nev, setNev] = useState('');
  const [jelszo, setJelszo] = useState('');
  const [maradjak, setMaradjak] = useState(true);
  const [hiba, setHiba] = useState<string | null>(null);
  const [munkaban, setMunkaban] = useState(false);
  const elsoMezo = useRef<HTMLInputElement>(null);

  useEffect(() => {
    elsoMezo.current?.focus();
  }, []);

  async function belep(e: React.FormEvent) {
    e.preventDefault();
    if (munkaban) return;
    setMunkaban(true);
    setHiba(null);
    try {
      const v = await api.post<EnValasz>('/api/belepes', {
        felhasznalonev: nev,
        jelszo,
        maradjak,
      });
      onBelepett(v);
    } catch (h) {
      setHiba(
        h instanceof ApiHiba && h.statusz === 401
          ? 'Hibás felhasználónév vagy jelszó.'
          : h instanceof Error
            ? h.message
            : 'A belépés nem sikerült.',
      );
      setJelszo('');
    } finally {
      setMunkaban(false);
    }
  }

  return (
    <div className="belep">
      <form className="beldoboz" onSubmit={belep}>
        <div className="belfej">
          <span className="belmark" />
          MHB CRM
        </div>

        <label htmlFor="bel-nev">Felhasználónév</label>
        <input
          id="bel-nev"
          ref={elsoMezo}
          value={nev}
          autoComplete="username"
          onChange={(e) => setNev(e.target.value)}
        />

        <label htmlFor="bel-jel">Jelszó</label>
        <input
          id="bel-jel"
          type="password"
          value={jelszo}
          autoComplete="current-password"
          onChange={(e) => setJelszo(e.target.value)}
        />

        <label className="belsw">
          <input type="checkbox" checked={maradjak} onChange={(e) => setMaradjak(e.target.checked)} />
          Maradjak bejelentkezve
        </label>

        <button className="btn pri" type="submit" style={{ width: '100%', marginTop: 12 }} disabled={munkaban}>
          {munkaban ? 'Belépés…' : 'Belépés'}
        </button>
        <div className="belhiba">{hiba ?? ''}</div>
      </form>
    </div>
  );
}
